import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import homeImage from '../../assets/homeheroImage.png';

export default function Hero() {
 return (
  <Container>
   <Wrapper>
    <div>
     <div className='header'>
      <Heading>Make Earth Green</Heading>
      <h2>Track, trace and fulfill your ERP targets</h2>
      <Linebreak>
       <div className='part1'></div>
       <div className='part2'></div>
       <div className='part3'></div>
      </Linebreak>
     </div>
     <Link to='bookDemo' target={'_blank'}>
      <div className='button'>Request Demo</div>
     </Link>
    </div>
    <div>
     <Image src={homeImage} alt='hand holding a small plant' />
    </div>
   </Wrapper>
  </Container>
 );
}

const Container = styled.div`
 width: 100%;
 height: auto;
 background: #000;
`;

const Wrapper = styled.div`
 display: flex;
 align-items: center;
 width: 65%;
 margin: 8rem auto 10rem auto;
 justify-content: space-between;

 > div {
  width: 50%;
  height: 100%;
  text-align: right;
 }
 > div:first-child {
  width: 40%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
 }
 @media screen and (max-width: 600px) {
  flex-direction: column;
  > div {
   width: 80%;
   text-align: center;
  }
  > div:first-child {
   text-align: center;
   width: 100%;
  }
 }
 .header {
  width: 100%;
  text-align: left;
  h2 {
   color: #fff;
   font-weight: 700;
   font-size: 2.5rem;
  }
 }
 .button {
  background: #90d62b;
  border-radius: 1rem;
  color: #e8e8e8;
  font-size: 1.5rem;
  width: fit-content;
  padding: 0.5rem 2rem;
  margin-right: auto;
  font-weight: 600;
  cursor: pointer;
 }
`;

const Heading = styled.h1`
 font-size: 3.5rem;
 font-weight: 700;
 line-height: 7rem;
 /* font-family: 'Segoe UI'; */
 color: #90d62b;
`;

const Linebreak = styled.div`
 width: 25%;
 display: flex;
 gap: 0.5rem;
 margin-top: 1rem;
 div {
  background-color: #84d908;
  border-radius: 1rem;
  height: 0.5vh;
 }
 .part1 {
  width: 40%;
 }
 .part2 {
  width: 30%;
 }
 .part3 {
  width: 10%;
 }
`;

const Image = styled.img`
 width: 85%;
 height: auto;
 object-fit: cover;
`;
